// Business on bots whatsapp widget js
var logo = document.createElement("IMG");
logo.src = "https://cdn.shopify.com/s/files/1/0567/5106/3210/files/wa-logo-120.png?v=1677232137";
logo.width = "40";
logo.height = "40";
logo.alt = "whatsapp icon";
var a = document.createElement('a');
a.appendChild(logo);
a.title = "Chat with us on WhatsApp";
a.href = "https://wa.me/+918591726106?text=Hi";
a.style.zIndex = 5;
a.style.position = "fixed";
if(location.href.includes('products')){
  a.style.bottom = "124px";
}else{
  a.style.bottom = "50px";
}
a.style.left = "0px";
a.style.padding = "10px";
var clientName = "Panchamrit"
document.body.appendChild(a);
a.target="_blank"
a.onclick = (()=>{
  updateCount('WHATSAPP_REDIRECTION')
})
function updateCount(eventName){
  var newPrimaryHashKey = "obj_name:" + generateRowId(4);
  const payload = {
    id: clientName + newPrimaryHashKey,
    clientName: clientName,
    dateTime: new Date().toUTCString(),
    eventName: eventName
  }
  fetch('https://n7ze0y2wwa.execute-api.ap-south-1.amazonaws.com/default/', {
    method: "POST",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(data=> data.json()).then(data=>{}).catch((error)=>{})
}
function generateRowId(shardId /* range 0-64 for shard/slot */) {
  var CUSTOMEPOCH = 1300000000000;
  var ts = new Date().getTime() - CUSTOMEPOCH; // limit to recent
  var randid = Math.floor(Math.random() * 512);
  ts = (ts * 64);   // bit-shift << 6
  ts = ts + shardId;
  return (ts * 512) + randid;
}